import React, { useContext, useState, useEffect } from "react"

import { Button } from "react-bootstrap"
import Actions from "./actions"

import ChatBox from "./ChatBox"

import ChatContext, { Provider } from "./ChatContext"

const UnreadChatDot = ({ className = "" }) => <div className={className} />

const ChatButton = ({ buttonStyle = false }): JSX.Element => {
  const { conversation, updateConversation } = useContext(ChatContext)

  const [isVisible, setIsVisible] = useState(false)

  const [wrapperClass, setWrapperClass] = useState("fs-5")

  const [messageIconClass, setMessageIconClass] = useState("fas fa-comment")

  useEffect(() => {
    if (isVisible && conversation.isUnread && conversation.id) {
      Actions.markAsRead({ conversationId: conversation.id }).then(() =>
        updateConversation({ isUnread: false, isRead: true })
      )
    }
  }, [isVisible])

  useEffect(() => {
    if (conversation && conversation.messages && conversation.messages.length > 0) {
      console.log("conversation", conversation)
      setMessageIconClass("fas fa-comment-dots text-warning")
    }
  }, [conversation])

  /* HACK: We use the key DOM attribute below to trigger the re-rendering of the nested icon (Bootstrap icon woes) */
  return (
    <div>
      <a
        key={messageIconClass}
        className={wrapperClass}
        role="button"
        onClick={() => setIsVisible(!isVisible)}
      >
        {!buttonStyle && (
          <span style={{ position: "relative", width: "40px" }}>
            <i key="comment" className={messageIconClass} />
            {conversation.isUnread && <UnreadChatDot className="unread-chat-dot" />}
          </span>
        )}
        {buttonStyle && (
          <>
            <Button>
              <i key="comment" className={`${messageIconClass} me-2`} />
              Chat
            </Button>
            {conversation.isUnread && <UnreadChatDot className="unread-chat-dot ms-2 mt-1" />}
          </>
        )}
      </a>
      <ChatBox isVisible={isVisible} onClose={() => setIsVisible(false)} />
    </div>
  )
}

const Wrapper = ({ chat }): JSX.Element => (
  <Provider conversation={chat}>
    <ChatButton buttonStyle={false} />
  </Provider>
)

export default Wrapper
